import { z } from 'zod';
import { baseComponentSchema } from '../component-base.schemas';

const hexColorRegex = /^#[0-9A-Fa-f]{6}$/;

export const statsCustomColorsSchema = z
  .object({
    background: z.string().regex(hexColorRegex, 'Invalid hex color').optional(),
    title: z.string().regex(hexColorRegex, 'Invalid hex color').optional(),
    subtitle: z.string().regex(hexColorRegex, 'Invalid hex color').optional(),
    value: z.string().regex(hexColorRegex, 'Invalid hex color').optional(),
    label: z.string().regex(hexColorRegex, 'Invalid hex color').optional(),
    description: z.string().regex(hexColorRegex, 'Invalid hex color').optional(),
  })
  .optional();

export const statsItemSchema = z.object({
  label: z.string().max(100, 'Label too long'),
  value: z.number(),
  prefix: z.string().max(10, 'Prefix too long').optional(),
  suffix: z.string().max(10, 'Suffix too long').optional(),
  description: z.string().max(200, 'Description too long').optional(),
});

export const statsDataSchema = z.object({
  title: z.string().max(200, 'Title too long').optional(),
  subtitle: z.string().max(500, 'Subtitle too long').optional(),
  items: z.array(statsItemSchema).default([]),
  layout: z.enum(['row', 'grid']).default('row').optional(),
  columns: z.number().int().min(2).max(4).default(3).optional(),
  animated: z.boolean().default(true).optional(),
  animationDuration: z.number().int().min(500).max(5000).default(2000).optional(),
  customColors: statsCustomColorsSchema,
});

export const statsComponentSchema = baseComponentSchema.extend({
  type: z.literal('stats'),
  data: statsDataSchema,
});

export type StatsCustomColors = z.infer<typeof statsCustomColorsSchema>;
export type StatsItem = z.infer<typeof statsItemSchema>;
export type StatsData = z.infer<typeof statsDataSchema>;
export type StatsComponent = z.infer<typeof statsComponentSchema>;
